import { getStore } from '../store/store';

export default function isImportLoaded(id: string): boolean {
    return getStore().loadedImports.has(id);
}
